import { FC } from "react";
import { TiposPagamento } from "src/components/pagamento/TiposPagamento";

const Pagamento: FC = () => {
    return <>
        <TiposPagamento pagamento={null} />
    </>
}

export { Pagamento }